export default __webpack_public_path__ + "static/media/CircularSawImg.5988cbfa.jpg";